import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { fmtMoney, PAYMENT_LABEL } from './format';

export const exportStatsToPDF = (stats: any) => {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.text('Chernova CRM — Отчёт', 14, 20);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.text(`Период: ${stats.period.from} — ${stats.period.to}`, 14, 28);
  doc.text(`Сгенерирован: ${new Date().toLocaleString('ru-RU')}`, 14, 34);

  autoTable(doc, {
    startY: 42,
    head: [['Финансы', 'Значение']],
    body: [
      ['Выручка', fmtMoney(stats.finance.revenue_total)],
      ['  С записей', fmtMoney(stats.finance.revenue_appointments)],
      ['  Прочие доходы', fmtMoney(stats.finance.revenue_other ?? 0)],
      ['  За работу', fmtMoney(stats.finance.revenue_work)],
      ['  За волосы', fmtMoney(stats.finance.revenue_hair)],
      ['  За распутывание', fmtMoney(stats.finance.revenue_tangle ?? 0)],
      ['  За доп. услуги', fmtMoney(stats.finance.revenue_extras)],
      ['Расходы (волосы)', fmtMoney(stats.finance.expenses_hair ?? 0)],
      ['Прочие расходы', fmtMoney(stats.finance.expenses_other ?? 0)],
      ['Расходы всего', fmtMoney(stats.finance.expenses_total)],
      ['Чистая прибыль', fmtMoney(stats.finance.profit)],
      ['Средний чек', fmtMoney(stats.finance.avg_check)],
      ['Долги', fmtMoney(stats.finance.debt)],
    ],
    headStyles: { fillColor: [139, 92, 246] },
  });

  autoTable(doc, {
    head: [['Услуга', 'Кол-во', 'Выручка']],
    body: stats.services.distribution.map((s: any) => [
      s.name,
      s.count,
      fmtMoney(s.revenue),
    ]),
  });

  autoTable(doc, {
    head: [['Способ оплаты', 'Сумма']],
    body: Object.entries(stats.finance.payments_distribution).map(([k, v]) => [
      PAYMENT_LABEL[k] ?? k,
      fmtMoney(v as number),
    ]),
  });

  autoTable(doc, {
    head: [['Категория расходов', 'Сумма']],
    body: stats.finance.expenses_by_category.map((c: any) => [c.name, fmtMoney(c.amount)]),
  });

  autoTable(doc, {
    head: [['Топ клиентов', 'Визиты', 'Сумма']],
    body: stats.clients.top.map((c: any) => [c.name, c.count, fmtMoney(c.revenue)]),
  });

  autoTable(doc, {
    head: [['Материалы', 'Значение']],
    body: [
      ['Использовано волос (г)', stats.materials.hair_grams_used.toFixed(0)],
      ['Прядей суммарно', stats.materials.total_strands],
      ['Остаток на складе (г)', stats.materials.stock_total_grams.toFixed(0)],
    ],
  });

  doc.save(`chernova-${stats.period.from}-${stats.period.to}.pdf`);
};
